/**
 * Widget Service
 * Handles API calls for the embedded lead-capture widget.
 * Uses the shared apiClient (Axios) for auth, CSRF, and credentials.
 */

import apiClient from './apiClient';

class WidgetService {
  async _request(method, endpoint, payload = null) {
    // Widget endpoints are always fetched fresh
    const config = {
      params: { t: Date.now() },
      headers: { 'Cache-Control': 'no-store' },
    };

    const { data } =
      method === 'POST'
        ? await apiClient.post(endpoint, payload, config)
        : await apiClient.get(endpoint, config);

    return {
      success: data.success !== undefined ? data.success : true,
      data: data.data ?? data,
    };
  }

  async getAgencyConfig(agencyId) {
    try {
      return await this._request('GET', `/api/widget/config/${agencyId}`);
    } catch (error) {
      console.error('[WidgetService] getAgencyConfig failed:', error);
      return {
        success: false,
        data: {
          title: 'Request a Quote',
          primaryColor: '#3B82F6',
          showAgentSelection: true,
          agencyName: 'Your Travel Agency',
          agencyLogo: null,
        },
        error: error.message,
      };
    }
  }

  async getAgencyAgents(agencyId) {
    try {
      return await this._request('GET', `/api/widget/agents/${agencyId}`);
    } catch (error) {
      console.error('[WidgetService] getAgencyAgents failed:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  async submitLead(leadData) {
    try {
      return await this._request('POST', '/api/widget/leads', leadData);
    } catch (error) {
      console.error('[WidgetService] submitLead failed:', error);
      return { success: false, data: null, error: error.message };
    }
  }
}

export default new WidgetService();
